<template>
	<div>
		<v-overlay v-if="loading" :value="loading" absolute>
			<v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-row align="center" no-gutters>
			<v-col cols="12" class="text-left">
				<v-select
					v-if="places.length > 0"
					v-model="placeSelected"
					class="mt-2 mr-2 d-inline-block"
					append-icon="mdi-home-group"
					dense
					filled
					solo
					hide-details
					label="Establecimientos"
					placeholder="Seleccione"
					no-data-text="No hay establecimientos agregados"
					outlined
					persistent-hint
					:hint="selectService ? `servicio: ${selectService.name}` : ''"
					:items="itemsPlaces"
					@change="setPlace"
				/>
				<place-Form-dialog class="my-2" />
			</v-col>
			<v-col
				v-if="Boolean(selectedPlace) && $route.name != 'all-activities'"
				cols="12"
				class="text-left"
			>
				<v-btn text color="primary" class="ma-sm-2 my-2" to="activities" link small>
					<v-icon left>mdi-chart-timeline</v-icon>
					<span>Actividades</span>
				</v-btn>
				<v-btn text color="primary" class="ma-sm-2 my-2" to="notifications" link small
					><v-icon left>
						mdi-bell-ring-outline
					</v-icon>
					Notificaciones
				</v-btn>
				<!-- <v-btn text color="primary" class="ma-sm-2 my-2" to="payments" link small>
					<v-icon left>
						mdi-credit-card-outline
					</v-icon>
					Pagos
				</v-btn> -->
				<v-btn text color="primary" class="ma-sm-2 my-2" to="documents" link small>
					<v-icon left>
						mdi-file-document-outline
					</v-icon>
					Documentos
				</v-btn>
				<v-btn text color="primary" class="ma-sm-2 my-2" to="assistance" link small>
					<v-icon left>
						mdi-badge-account-horizontal-outline
					</v-icon>
					Asistencia
				</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-col v-if="!places.length" cols="12">
				<data-empty
					title="Presione el boton de aquí arriba para iniciar."
					msj="Aún no tiene ningun establecimiento para generar actividades."
				/>
			</v-col>
			<v-col v-else-if="!selectPlaceService && placeSelected != 'Ver todos'" cols="12">
				<data-empty
					background-color="transparent"
					title="Para continuar"
					:msj="titleNoSeleted"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

let moment = extendMoment(Moment);
export default {
	name: 'Header',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
		PlaceFormDialog: () => import('@/components/place/PlaceFormDialog'),
	},
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		selectPlaceService: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			changePlace: true,
			selectService: null,
			dialogPayments: false,
			placeSelected: 'Ver todos',
		};
	},
	computed: {
		itemsPlaces() {
			return ['Ver todos', ...this.places];
		},
		titleNoSeleted() {
			let titlePlace = '';
			let titleService = '';
			let connector = '';
			if (!this.validated(this.placeSelected)) titlePlace = 'un establecimiento';
			if (titlePlace != '' && titleService != '') connector = 'y';
			return `Por favor seleccione ${titlePlace} ${connector} ${titleService}`;
		},
		avalaiblesServices() {
			let services = [];
			if (this.selectedPlace)
				this.places.forEach(place => {
					if (place.value === this.selectedPlace.value && place.services)
						return place.services.forEach(service => {
							services.push({
								value: service,
								text: service.name,
								price: service.price,
							});
						});
				});
			return services;
		},
		...mapGetters({
			places: 'Lodging/places',
			hasNewPlace: 'Place/hasNewPlace',
			selectedPlace: 'Lodging/selectedPlace',
			rangeDate: 'Lodging/rangeDate',
		}),
	},
	mounted() {
		this.setSelectedPlace(null);
		this.selectServices(null);
		if (this.$route.name !== 'all-activities') this.$router.push({ name: 'all-activities' });
	},
	methods: {
		getAllLodgings() {},
		validated(value) {
			return value !== null && value != undefined;
		},
		setSelectPlaceService() {
			const selected =
				this.validated(this.placeSelected) &&
				this.avalaiblesServices.length > 0 &&
				this.validated(this.selectService);
			this.$emit('setSelectPlaceService', selected);
		},
		async setPlace(value) {
			if (value == 'Ver todos') {
				if (this.$route.name !== 'all-activities')
					this.$router.push({ name: 'all-activities' });
				this.setSelectedPlace(null);
				this.selectServices(null);
				return;
			}
			if (this.$route.name !== 'activities') this.$router.push({ name: 'activities' });
			await this.fetchLodgings(value);
			this.setSelectedPlace(value);
			this.setServicesComboBox();
			this.selectService = this.selectedPlace.services[0];
			this.selectServices(this.selectedPlace.services[0]);
			this.setUpdateMap();
		},
		async exportToPdf() {
			try {
				const pdf = await this.generatePdfReport({
					idPlace: this.placeSelected,
					date: moment(this.rangeDate.start).format('DD-MM-YYYY'),
				});
				let blob = new Blob([pdf], { type: 'application/pdf' });
				let link = document.createElement('a');
				let toDay = new Date();
				link.href = window.URL.createObjectURL(blob);
				link.download =
					this.selectedPlace.text +
					' ' +
					this.selectedPlace.services[0].name +
					' ' +
					moment(toDay).format('MMMM YYYY');
				link.click();
			} catch (error) {
				this.snackbar({
					content: error.message,
					color: 'error',
				});
			}
		},
		async exportToCsv() {
			try {
				const csv = await this.generateCsvReport(this.placeSelected);
				let toDay = new Date();
				let blob = new Blob([csv], { type: 'text/csv' });
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download =
					this.selectedPlace.text +
					' ' +
					this.selectedPlace.services[0].name +
					' ' +
					moment(toDay).format('MMMM YYYY');
				link.click();
			} catch (error) {
				this.snackbar({
					content: error.message,
					color: 'error',
				});
			}
		},
		...mapActions({
			fetchLodgings: 'Lodging/fetchLodgings',
			generateCsvReport: 'Lodging/generateCsvReport',
			generatePdfReport: 'Lodging/generatePdfReport',
		}),
		...mapMutations({
			selectServices: 'Lodging/selectServices',
			setModeEdit: 'Lodging/setModeEdit',
			setSelectedPlace: 'Lodging/setSelectedPlace',
			setServicesComboBox: 'Lodging/setServicesComboBox',
			setUpdateMap: 'Lodging/setUpdateMap',
			snackbar: 'Snackbar/showMessage',
		}),
	},
	watch: {
		// Establece el nuevo place creado
		hasNewPlace(newVal) {
			if (newVal) {
				this.placeSelected = this.places[this.places.length - 1]._id;
				this.setPlace(this.placeSelected);
			}
		},
		selectService() {
			this.setSelectPlaceService();
		},
	},
};
</script>
